import { SortDirection } from '@/shared/api/lib';
import type { SortingState } from '@tanstack/react-table';
import { useState } from 'react';

export const useTableSortingState = <T extends string>(defaultState?: {
  sortBy: T;
  sortDirection: 'asc' | 'desc';
}) => {
  const [sortingState, setSortingState] = useState<SortingState>(
    defaultState
      ? [
          {
            id: defaultState.sortBy,
            desc: defaultState.sortDirection === 'desc',
          },
        ]
      : []
  );

  const sortBy = (sortingState?.[0]?.id ?? defaultState?.sortBy) as T;
  const sortDirection: SortDirection = sortingState[0]
    ? sortingState[0].desc
      ? SortDirection.DESC
      : SortDirection.ASC
    : defaultState?.sortDirection === 'desc'
      ? SortDirection.DESC
      : SortDirection.ASC;

  return {
    sortBy,
    sortDirection,
    sortingState,
    setSortingState,
  };
};
